export default function (dateString) {
  return dateString
    .split("-")
    .map((part) => part.padStart(2, "0"))
    .join("-");
}
